import React from 'react';
import classNames from 'classnames';
import { Stack } from '@moda/om';
import { formatPrice } from '../../lib/formatPrice';
import { priceToNumber } from '../../lib/priceToNumber';
import { AffirmPromoMessage } from '../AffirmPromoMessage';
import { ProductDetailsFragment_otherVariants_prices_currentPrice as Price } from '../../generated/types/ProductDetailsFragment';
import { EstimatedVatLink } from '../EstimatedVatLink';
import { getRoundedMarkdownPercent } from '../../lib/variantUtils/getRoundedMarkdownPercent';

import './PDPProductPrice.scss';

interface Props extends React.HTMLProps<HTMLDivElement> {
  depositPrice: Price | null;
  originalPrice: Price | null;
  currentPrice: Price | null;
  vatPrice?: Price | null;
}

export const PDPProductPrice: React.FC<Props> = ({
  className,
  depositPrice,
  originalPrice,
  currentPrice,
  vatPrice,
  children
}) => {
  const markdownPercent = getRoundedMarkdownPercent({
    currentPrice: Number(currentPrice?.price || '0.0'),
    originalPrice: Number(originalPrice?.price || '0.0')
  });

  return (
    <Stack className={className} space={1}>
      <Stack
        alignItems="center"
        className={classNames('PDPProductPrice', className)}
        direction="horizontal"
        justifyContent="center"
        space={1}
      >
        {originalPrice &&
          currentPrice &&
          Number(originalPrice.price) !== Number(currentPrice.price) && (
            <div className="PDPProductPrice__original-price">
              {formatPrice(originalPrice.currency, originalPrice.price)}
            </div>
          )}

        {currentPrice && (
          <span className="PDPProductPrice__current-price">
            {formatPrice(currentPrice.currency, currentPrice.price)}
          </span>
        )}

        {markdownPercent > 0 && (
          <span className="PDPProductPrice__markdown-percent">Save {markdownPercent}%</span>
        )}

        {children}
      </Stack>

      {priceToNumber(depositPrice?.price) === 0 && (
        <AffirmPromoMessage pageType="product" price={Number(currentPrice?.price)} />
      )}
      {vatPrice && currentPrice && (
        <EstimatedVatLink currentPrice={currentPrice} vatPrice={vatPrice} />
      )}
    </Stack>
  );
};
